/** Whether the home health demo layer is on for the current organization (one hook for the product's slot points). */
import { useOrganization } from "~/providers/GraphqlProvider";
import { isHomeHealthDemoEnabled } from "./demoEnabled";

export function useHomeHealthDemoEnabled(): boolean {
  const { organizationName } = useOrganization();
  return isHomeHealthDemoEnabled(organizationName);
}
